import React from 'react';
import {Dialog} from "primereact/dialog";
import {jsPDF} from "jspdf";
import {Toast} from 'primereact/toast';

class MapCapture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mapElement: null,
            capturedImage: null,
            loading: false
        };

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(now.getDate()).padStart(2, '0');
        this.imageName = `mapa-captura-${year}-${month}-${day}.jpeg`;
    }

    componentDidMount() {
        console.log('Mapa captura montada');
    }

    copyToClipboard = async () => {

        try {
            await this.props.canvas.toBlob(async (blob) => {

                await this.setState({
                    ...this.state,
                    loading: true
                });

                const item = new ClipboardItem({'image/png': blob});

                navigator.clipboard.write([item]).then(async () => {
                    console.log("O mapa foi copiado para a área de transferência.");

                    await this.setState({
                        ...this.state,
                        loading: false
                    });

                    this.toast.show({severity: 'success', summary: 'Copiar Imagem', detail: 'Imagem copiada para a area de transferência!', life: 3000});

                });
            }, 'image/png', 2.0);
        } catch (e) {
            console.log(e);
        } finally {
            await this.setState({loading: false});
        }
    }

    downloadPDF = async () => {

        return new Promise((resolve, reject) => {
            try {
                const canvas = this.props.canvas;

                const pdf = new jsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4'
                });

                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();

                let imgWidth = pageWidth;
                let imgHeight = (canvas.height * imgWidth) / canvas.width;

                // Se a altura extrapolar, ajusta pela altura
                if (imgHeight > pageHeight) {
                    const ratio = pageHeight / imgHeight;
                    imgWidth *= ratio;
                    imgHeight *= ratio;
                }

                const x = (pageWidth - imgWidth) / 2;
                const y = (pageHeight - imgHeight) / 2;

                pdf.addImage(this.props.imageData, 'JPG', x, y, imgWidth, imgHeight);

                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');

                const fileName = `mapa-captura-${year}-${month}-${day}.pdf`;

                resolve(pdf.save(fileName));

            } catch (error) {
                console.error("Erro ao baixar o PDF:", error);
                reject(error);
            }
        })

    }

    render() {
        return (

            <React.Fragment>
                <Toast ref={(el) => this.toast = el} position="bottom-right"/>

                <Dialog
                    header="Salvar Mapa"
                    visible={this.props.visible}
                    style={{width: '60vw', marginTop: '30px'}}
                    onHide={this.props.handleClose}
                    blockScroll={true}
                >
                    <div className="card" style={{paddingBottom: '0', marginBottom: '0'}}>
                        <div className="card-body" id="capture-map-container">
                            <img alt="Mapa" src={this.props.imageData} style={{
                                width: '100%',
                                height: '70vh',
                                objectFit: 'cover'
                            }}/>
                        </div>
                        <div className="card-footer" style={{paddingBottom: '0'}}>
                            <div className="d-flex justify-content-end align-items-end" style={{gap: '10px'}}>
                                <button disabled={this.state.loading} className="btn btn-rect btn-danger"
                                        onClick={async (e)=>{
                                            await this.setState({ loading: true });
                                            setTimeout(() => {
                                                this.downloadPDF().finally(() => {
                                                    this.setState({ loading: false });
                                                });
                                            }, 100);
                                        }}
                                >PDF &nbsp;{this.state.loading &&
                                    <i className="fas fa-spinner fa-spin"></i>}
                                </button>
                                <a href={this.props.imageData} download={this.imageName}
                                   className="btn btn-rect btn-info">JPEG &nbsp;{this.state.loading &&
                                    <i className="fas fa-spinner fa-spin"></i>}</a>
                                <button disabled={this.state.loading}
                                        onClick={this.copyToClipboard}
                                        className="btn btn-rect btn-default">COPIAR &nbsp;{this.state.loading &&
                                    <i className="fas fa-spinner fa-spin"></i>}</button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default MapCapture;
